export function thresholdsToIntervals(thresholds: number[]): Array<{ min: number; max: number }> {
	const output = new Array<{ min: number; max: number }>(thresholds.length - 1);
	for (let i = 0; i < output.length; i++) {
		output[i] = { min: thresholds[i], max: thresholds[i + 1] };
	}
	return output;
}

export function numberToInputStep(num: number): number {
    const numStr = num.toString();

    if (numStr.includes('e')) {
        const [, exponent] = numStr.split('e');
        return Math.abs(parseInt(exponent));
    }

    if (!numStr.includes('.')) {
        return 0;
    }

    return numStr.split('.')[1].length;
}
